// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Button, Icon } from '@pwc/pwc-deals-ui';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import './GroupMenu.scss';
import { useTranslation } from 'react-i18next';
import RowActionsButton from 'common/components/ContentActions/RowActionsButton';

type Props = {
  handleDelete: () => void;
  handleRename: () => void;
  handleMoveUp: () => void;
  handleMoveDown: () => void;
  enableDragAndDrop: boolean;
};
const GroupMenu: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    handleDelete,
    handleRename,
    handleMoveUp,
    handleMoveDown,
    enableDragAndDrop,
  } = props;
  const { t } = useTranslation();
  const popover = (
    <Popover id="menu-group" className="group-menu">
      <Popover.Content className="popup-menu">
        <div className="analyses-group-menu__popup">
          <Button
            className="ui-button button-menu"
            onClick={handleDelete}
            icon=""
            iconClasses=""
          >
            <Icon name="bin" width="21" className="sr2 outline icon-orange" />
            {t('deleteGroup')}
          </Button>
          <Button
            className="ui-button button-menu"
            onClick={handleRename}
            icon=""
            iconClasses=""
          >
            <Icon
              name="pencil"
              width="21"
              className="sr2 outline icon-orange"
            />
            {t('renameGroup')}
          </Button>
          {enableDragAndDrop && (
            <>
              <Button
                className="ui-button button-menu mobile-display"
                onClick={handleMoveUp}
                icon=""
                iconClasses=""
              >
                <Icon
                  name="move-up"
                  width="21"
                  className="sr2 outline icon-orange"
                />
                Move up
              </Button>
              <Button
                className="ui-button button-menu button-group-menu-move mobile-display"
                onClick={handleMoveDown}
                icon=""
                iconClasses=""
              >
                <Icon
                  name="move-down"
                  width="21"
                  className="sr2 outline icon-orange"
                />
                Move down
              </Button>
            </>
          )}
        </div>
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger="click"
      placement="left-start"
      overlay={popover}
      rootClose
    >
      <RowActionsButton />
    </OverlayTrigger>
  );
};

export default GroupMenu;
